module.exports = __webpack_public_path__ + "img/lagoon.bda922c9.jpg";